import React, { useRef, useState, useEffect } from 'react';

const ImageUploader = ({ currentImageUrl, onFileSelect, label = 'Subir Imagen' }) => {
  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(currentImageUrl || null);

  useEffect(() => {
    setPreview(currentImageUrl || null);
  }, [currentImageUrl]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        alert('Por favor selecciona un archivo de imagen válido.');
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result);
      reader.readAsDataURL(file);
      onFileSelect(file);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setPreview(null);
    onFileSelect(null);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <div className="form-group">
      <label>{label}</label>
      <div
        className={`image-upload-area ${preview ? 'has-image' : ''}`}
        onClick={handleClick}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept="image/*"
          style={{ display: 'none' }}
        />
        {preview ? (
          <>
            <img src={preview} alt="Vista previa" className="image-preview" />
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={(e) => {
                  e.stopPropagation();
                  handleClick();
                }}
              >
                Cambiar imagen
              </button>
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={handleRemove}
              >
                Quitar
              </button>
            </div>
          </>
        ) : (
          <p className="upload-text">
            <strong>Sube un archivo</strong> o arrástralo y suéltalo
          </p>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
